import * as React from "react";
const SvgTriangleDropDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 10L12 15L17 10H7Z" }));
export { SvgTriangleDropDown as ReactComponent };
